import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-20 bg-surface" data-id="element-185">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-186">
        <div className="text-center mb-16" data-id="element-187">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-188">
            ELEGÍ TU PACK
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-189">
          {/* Standard Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl p-8 border border-gray-200 shadow-sm flex flex-col" data-id="element-190">
            <div className="text-2xl mb-4" data-id="element-191">📘</div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-192">
              MEGAPACK OPERATIVO AIRBNB MANAGER
            </h3>
            <p className="text-primary font-bold mb-6" data-id="element-193">6 Tomos + 6 Bonos</p>

            <div className="bg-gray-50 p-4 rounded-xl mb-8 text-sm text-gray-600" data-id="element-194">
              Para quien quiere arrancar o escalar su gestión de propiedades en
              dólares.
            </div>

            <div className="mb-8" data-id="element-195">
              <div className="text-gray-400 line-through text-lg font-medium" data-id="element-196">
                $69.000
              </div>
              <div className="text-4xl font-extrabold text-gray-900" data-id="element-197">
                $19.990{' '}
                <span className="text-lg text-gray-500 font-medium" data-id="element-198">ARS</span>
              </div>
            </div>

            <a href="https://www.iterapro.shop/checkouts/cn/hWNBlFOOMww9wDpt5gWKQ5lS/es-ar?_r=AQABqj-sTAqS3u_oZF2xIAQCkLeqZFjYy96SSuUsFF8v3MM&cart_link_id=0TVX6ial&preview_theme_id=163813163097" target="_blank" rel="noopener noreferrer" className="w-full py-4 px-6 bg-gray-900 hover:bg-gray-800 text-white font-bold rounded-xl transition-colors mt-auto block text-center" data-id="element-199">
              🔴 QUIERO MI MEGAPACK AHORA
            </a>
          </motion.div>

          {/* Premium Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white rounded-3xl p-8 border-2 border-primary shadow-xl relative flex flex-col transform md:-translate-y-4" data-id="element-200">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gradient-to-r from-primary to-secondary text-white px-4 py-1 rounded-full text-sm font-bold flex items-center gap-1 shadow-md" data-id="element-201">
              <Star className="w-4 h-4 fill-white" data-id="element-202" /> MÁS COMPLETO
            </div>

            <div className="text-2xl mb-4" data-id="element-203">🏆</div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-204">
              MEGAPACK + AIRBNB AGENCY AUTOPILOT
            </h3>
            <p className="text-primary font-bold mb-6" data-id="element-205">
              6 Tomos + 6 Bonos + Sistema de Automatización y Escala 10X
            </p>

            <div className="bg-primary/5 p-4 rounded-xl mb-8 text-sm text-gray-600 border border-primary/10" data-id="element-206">
              Para quien quiere automatizar operaciones, implementar IA y
              construir una agencia que funciona sin él.
            </div>

            <div className="mb-8" data-id="element-207">
              <div className="text-gray-400 line-through text-lg font-medium" data-id="element-208">
                $99.000
              </div>
              <div className="text-5xl font-extrabold text-gray-900" data-id="element-209">
                $27.990{' '}
                <span className="text-lg text-gray-500 font-medium" data-id="element-210">ARS</span>
              </div>
            </div>

            <a href="https://www.iterapro.shop/checkouts/cn/hWNBlFpkQuaRfGOqNFIpRtFi/es-ar?_r=AQABnBnndoOdALJIPgswgvjHMyaiuxYxIqBDx8cHiSBmcw8&cart_link_id=Refm8t97&preview_theme_id=163813163097" target="_blank" rel="noopener noreferrer" className="w-full py-4 px-6 bg-gradient-to-r from-primary to-secondary hover:shadow-lg hover:shadow-primary/30 text-white font-bold rounded-xl transition-all mt-auto transform hover:scale-[1.02] block text-center" data-id="element-211">
              🔴 QUIERO EL MEGAPACK + AUTOPILOT
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}